import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface CtaButtonProps {
  event: string;
  label: string;
  onClick: () => void;
  selected: string | null;
  setSelected: (selected: string | null) => void;
  value: string;
}

export const CtaButton = ({ label, onClick }: CtaButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(
      "border-secondary flex h-8 w-[272px] items-center justify-center rounded-full bg-[#2B2E33] px-6 font-medium text-white transition-colors",
      "hover:bg-[#363A40] focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2",
    )}
  >
    <Typography.LabelSm weight="medium" color="inverse">
      {label}
    </Typography.LabelSm>
  </button>
);
